import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { reportSalesByZoneWholesalerTypes } from "redux/reducers/Reports/reportSalesByZoneWholesaler/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_SALES_BY_ZONE_WHOLESALER_FILTERS } = reportSalesByZoneWholesalerTypes;

export const getReportSalesByZoneWholesalerAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    dispatch(startRequestComp('loadingSalesByZoneWholesaler'));
    try {
      const url = `${process.env.REACT_APP_URL}${PROYECT}/reports/sales-by-zone-wholesaler?idStation=${station.id}&start=${startDate}&end=${endDate}&pdf=${isPdf}`;
      const res = await axios.get(url, {
        headers: { authorization: token },
        responseType: "blob"
      });

      saveAs(res.data, `Reporte_Venta_por_zona_Mayoristas_${station.name}_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingSalesByZoneWholesaler'));
    }
  };
};

export const setReportSalesByZoneWholesalerFilters = (key = "", value) => ({
  type: SET_SALES_BY_ZONE_WHOLESALER_FILTERS,
  payload: { key, value }
});
